import React from 'react';
import ReactDOM from "react-dom";
import Axios from 'axios';
//import { Link } from 'react-router-dom';
import ShopProfile from './shopProfile';
import Filter from './filter';
import Product from './product';
import AddBasket from './addBasket';
//import Breadcrumb from './breadcrumb';
import Breadcrumb from './bread-crumb';
import '../mainCSS/products.css';

export default class Products extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            products: [null],
            pSum: null
        };
    }

    componentDidMount() {
        var url = ShopProfile.getURL() + '/index/reactFetch.php';
        var data = new URLSearchParams({
            event: 'narrow-products-data',
            min: ShopProfile.getPriceMin(),
            max: ShopProfile.getPriceMax(),
            categoryID: ShopProfile.getCategoryID(),
            groupID: ShopProfile.getGroupID(),
            value: ShopProfile.getNavFrom(),
            //brands: JSON.stringify(ShopProfile.getBrands()),
            brandsID: JSON.stringify(ShopProfile.getBrandsID()),
            sizesID: JSON.stringify(ShopProfile.getSizesID()),
            featuresID: JSON.stringify(ShopProfile.getFeaturesID()),
            sum: 1,
            reverse: false
        });
        Axios.post(url, data)
            .then(res => {
                this.setState({
                    products: res.data,
                    pSum: res.data[0]['pSum']
                })
            })
            .catch(() => {
                this.lineNone();
              });
    }

    //Nem kérem le a termékekről az összes termék infót.
    getNarrowProductsData() {
        var url = ShopProfile.getURL() + '/index/reactFetch.php';
        var data = new URLSearchParams({
            event: 'narrow-products-data',
            min: ShopProfile.getPriceMin(),
            max: ShopProfile.getPriceMax(),
            categoryID: ShopProfile.getCategoryID(),
            groupID: ShopProfile.getGroupID(),
            value: ShopProfile.getNavFrom(),
            //brands: JSON.stringify(ShopProfile.getBrands()),
            brandsID: JSON.stringify(ShopProfile.getBrandsID()),
            sizesID: JSON.stringify(ShopProfile.getSizesID()),
            featuresID: JSON.stringify(ShopProfile.getFeaturesID()),
            sum: 0,
            reverse: false
        });
        Axios.post(url, data)
            .then(res => {
                this.setState({
                    products: res.data
                })
            })
        this.render();
    }

    numberFormat(value) {
        return new Intl.NumberFormat('hu-HU', {
            style: 'currency',
            currency: 'HUF',
            maximumSignificantDigits: 5
        }).format(value);
    }

    imgeffectShow(el) {
        var div = document.getElementsByClassName(el);
        for (var i = 0; i < div.length; i++) {
            div[i].style = 'width: 100%; height: 50%; animation: fade 0.5s';
            div[i].style.display = 'block';
        }
    }

    imgeffectHide(el) {
        var div = document.getElementsByClassName(el);
        for (var i = 0; i < div.length; i++) {
            div[i].style = 'clear: both';
            //div[i].style.display = 'none';
        }
    }

    productsNext() {
        var value = ShopProfile.getNavValue() + 1;
        ShopProfile.setNavValue(value);
        ShopProfile.setNavFrom(ShopProfile.getNavStep() * value);
        //this.productsShow();
        this.getNarrowProductsData();
    }

    producstBack() {
        var value = ShopProfile.getNavValue() - 1;
        ShopProfile.setNavValue(value);
        ShopProfile.setNavFrom(ShopProfile.getNavStep() * value);
        //this.productsShow();
        this.getNarrowProductsData();
    }

    next() {
        return (
            <span className='navNext' onClick={() => this.productsNext()}>
                {' tovább '}<span className='next'></span>
            </span>
        );
    }

    back() {
        return (
            <span className='navBack' onClick={() => this.producstBack()}>
                <span className='back'></span>{' vissza '}
            </span>
        );
    }

    navBar(sum) {
        var value = ShopProfile.getNavValue();
        var step = ShopProfile.getNavStep();
        var next = '';
        if ((value + 1) * step < sum) {
            next = this.next();
        }
        var back = '';
        var valueShow = '';
        if (value > 0) {
            back = this.back();
            valueShow = ' | ' + value + ' | ';
        }
        return (
            <div className='pager'>
                <b>{'Összes termék: '}</b>
                {sum + ' '}
                {back}
                {valueShow}
                {next}
            </div>
        );
    }

    addBasketItem(productID, productName, size) {
        //Itt ki kell olvasni a darabszámot, ha nincs méret
        var piece;
        piece = document.getElementById("db-" + productID) ? piece = document.getElementById("db-" + productID).value : null;
        new AddBasket().addBasketItem(productID, productName, piece, size);
    }

    productShow(link) {
        new Product().productShow(link);
    }

    action(percentage) {
        return (
            <div className='action'>
                {'AKCIÓ ' + percentage + '%'}
            </div>
        );
    }

    actionPrice(price, percentage) {
        var aPrice = parseInt(price - (price * percentage) / 100);
        return (
            <b>
                <label>{this.numberFormat(price)}</label>
                {this.numberFormat(aPrice)}
            </b>
        );
    }

    price(price) {
        return (
            <b>
                {this.numberFormat(price)}
            </b>
        );
    }

    products() {
        var { products } = this.state;
        const res = products.map((product) =>
            <div key={product.productID} className='productItem'>
                <div className='img' onMouseOut={() => this.imgeffectHide(product.productID)}
                    onMouseOver={() => this.imgeffectShow(product.productID)}
                    onClick={() => this.productShow(product.link)}>
                    {product.percentage === null ? '' : this.action(product.percentage)}
                    <div className={'effect ' + product.productID}>
                        <div>
                            <h3>{'Erotika Store Szexshop'}</h3>
                            <p>{this.numberFormat(product.postCostLimit) + ' felett ingyenes kiszállítás'}</p>
                        </div>
                    </div>
                    <img src={product.picture} alt={product.pruductName} />
                </div>
                <div>
                    <h2>{product.main + ' - ' + product.category}</h2>
                    <p>{product.pruductName}</p>
                    <p>{'ÁR: '}{product.percentage === null ? this.price(product.price) : this.actionPrice(product.price, product.percentage)}</p>
                    <div className='button'>
                        <button className='buttonfx doubletake' onClick={() => this.productShow(product.link)}>{'Részletek'}</button>
                        <button className='buttonfx doubletake' onClick={() => this.addBasketItem(product.productID, product.pruductName, product.size)}>{product.size == null ?'Kosárba': 'Méretválasztás'}</button>
                    </div>
                    {product.size === null ? <input id={'db-' + product.productID} type='text' name='piece' defaultValue='1' /> : ''}
                </div>
            </div>
        );
        return res;
    }

    lineNone() {
        setTimeout(function () {
            ReactDOM.render(
                <p><h1>
                    {'Nincs találat'}
                </h1><hr /></p>,
                document.getElementById("title")
            );
        }, 10);
    }

    productsShow() {
        new Filter().productsShow();
    }

    breadCrumbShow(mainCategory, mainCategoryID, category, categoryID) {
        return (
            new Breadcrumb().breadCrumbShow(mainCategory, mainCategoryID, category, categoryID)
        );
    }

    render() {
        var { products } = this.state;
        var { pSum } = this.state;
        //var sum = '';
        var line = '';
        var mainCategory = '';
        var mainCategoryID = 0;
        var category = '';
        var categoryID = 0;
        var nav = '';
        var productsShow = '';
        var breadcrumb = '';
        //Az eredeti tömbböt fogja adni null értékre a rendere metodus
        if (products.length > 0 && products[0] !== null) {
            mainCategory = products[products.length - 1].main;
            mainCategoryID = products[0].mainCategoryID;
            category = products[products.length - 1].category;
            categoryID = products[0].categoryID
            //line = mainCategory + ' - ' + category;
            line = ShopProfile.getGroupID() === 0 ? mainCategory + ' - ' + category : mainCategory + ' - kategória termékei';
            nav = this.navBar(pSum);
            productsShow = this.products();
            breadcrumb = this.breadCrumbShow(mainCategory, mainCategoryID, category, categoryID);
        }
        return (
            <div>
                {breadcrumb}
                <div id='title'>
                    <h1>
                        {line}
                    </h1><hr />
                </div >
                {nav}
                {productsShow}
                {nav}
            </div >
        );
    }

}